import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const categoryStore = {
    actionCreators,
    reducer,
};

export default categoryStore;
